(function (ws) {
    'use strict';

    ws.views.checkoutShipping = ws.views.shipping.extend({

        events: _.extend({}, ws.views.shipping.prototype.events, ws.views.form.prototype.events, {
            'change #earliestRequiredShipDate': 'checkShippingDate',
            'change #addressBook': 'onSelectAddressBookChanged',
            'change #country': 'onCountryChange',
            'change #sameAsShippingAddress': function (e) {
                this.toggleEndUserAddress(e);
                this.onCountryChange();
            },

            'blur .spCheck': 'checkAttackValue',
            'blur .spCheckFrstName': 'checkAttackValue',
            'keyup .spCheck': 'checkAttackValue',
            'keyup .spCheckFrstName': 'checkAttackValue',
            'click .createNewAddress-endUser': 'newEndUserCreation',
            'click .createNewAddress-shipto': 'newShipToCreation'
        }),

        newEndUserCreation: function () {
            this.eventAgg.trigger('endUserAccountLookupModal');
            this.eventAgg.trigger('selectingFromLink');
        },

        newShipToCreation: function () {
            this.eventAgg.trigger('shipToAccountLookupModal');
            this.eventAgg.trigger('selectingFromLink');
        },

        avoidTriggeringInternalSearch: function () {
            this.triggerPopupdisabled = true;
        },

        addAddress: function () {
            if (this.triggerPopupdisabled) {
                this.triggerPopupdisabled = false;
                return;
            }

            this.eventAgg.trigger('shipToAccountLookupModal');
        },

        endUserAddAddress: function () {
            if (this.triggerPopupdisabled) {
                this.triggerPopupdisabled = false;
                return;
            }

            this.eventAgg.trigger('endUserAccountLookupModal');
        },

        /**
         * Initialize view
         */
        initialize: function () {
            ws.views.shipping.prototype.initialize.call(this);
            this.triggerPopupdisabled = false;

            // DOM elements assignments
            this.$endUserAddress = this.$('.end-user-addrs');
            this.$endUserAddressCheckbox = this.$('#sameAsShippingAddress');

            this.confirmModalId = $('.qut-clear-confirm').prop('id');
            this.eventAgg.on(this.confirmModalId + 'continue', this.clearQuote, this);

            this.toggleEndUserAddress();

            this.$addressBookSelect = $('#addressBook');
            this.$shippingAddressForm = $('#shippingAddressForm');
            this.$submitaddress = $('#submitaddress');
            this.$is3PLOrder = this.$('.is3PLOrder');
            this.$earliestRequiredShipDate = this.$('#earliestRequiredShipDate');
            this.$earlyRequiredShippingDateError = this.$('.early-required-shipping-date-error');
            this.$generalError = this.$('.generalError');
            this.$('.address-type-selector').on('change', this.onAddressEntryTypeChanged.bind(this));
            this.eventAgg.on('settingUpShippingAddressByMDM', this.settingUpShippingAddressByMDM.bind(this));
            this.shippingAddressModel = new ws.models.checkoutShippingAddressMdmValidation();
            this.shipVerifiedFromAddressBook = false;
            this.endUserVerifiedFromAddressBook = false;
            this.addressValidationEnabled = $('#enableAddressValidation').val() === 'true' ? true : false;
            this.shippingAddressAttn = '';
            this.endUserAddressAttn = '';

            this.eventAgg.on('avoidTriggeringInternalSearch', this.avoidTriggeringInternalSearch.bind(this));
            this.onCountryChange();
            this.setFormShippingAddress();
            this.render();
            this.phoneValidation();

            if ($('#enableMDMTrilliumAddressValidation').val() === 'true') {
                setTimeout(()=> {
                    $('#newAddress').on('change', () => {
                        this.addAddress();
                    });

                    $('#endUserNewAddress').on('change', () => {
                        this.endUserAddAddress();
                    });

                    this.newAddressCreateLinkTogle();
                }, 2000);
            }

            if (this.addressValidationEnabled) {
                this.addressSelctionHandler();

                if ($('#errorOnPage').val()) {
                    this.reSelectFromAddressBook();
                }
            }
        },

        newAddressCreateLinkTogle: function () {
            if ($('.shipping-section #newAddress').prop('checked')) {
                $(`.shipping-section`).find('.createAddressLink').removeClass('hide');
            }

            if ($('.endUser-section #endUserNewAddress').prop('checked')) {
                $(`.endUser-section`).find('.createAddressLink').removeClass('hide');
            }
        },

        addressSelctionHandler: function () {
            if ($('.addressFromMDMSugestion-shipping').length) {

                //Trick to clear inputfields and disable the addressSelection
                $('.shipping-section #selectFromAddress').click();

                //Remove Radio Selection
                $('.shipping-section #selectFromAddress').removeAttr('checked');

                //Make FieldSet disabled
                $('.shipping-section .selectFromAddress-fieldset').attr('disabled', 'true');
            }

            if ($('.addressFromMDMSugestion-endUser').length) {

                //Trick to clear inputfields and disable the addressSelection
                $('.endUser-section #endUserSelectFromAddress').click();

                //Remove Radio Selection
                $('.endUser-section #endUserSelectFromAddress').removeAttr('checked');

                //Make FieldSet disabled
                $('.endUser-section .endUserSelectFromAddress-fieldset').attr('disabled', 'true');

                if ($('#endUser-address-id').val() === $('#ship-address-id').val() && !$('#sameAsShippingAddress').prop('checked')) {
                    $('#sameAsShippingAddress').click();
                }
            }
        },

        reSelectFromAddressBook: function () {
            if ($('#ship-address-id').val()) {
                $('.shipping-section #selectFromAddress').click();
                $('.shipping-section #addressBook').val($('#ship-address-id').val()).select2({
                    minimumResultsForSearch: -1
                }).trigger('change');
            }

            if ($('#endUser-address-id').val()) {
                $('.endUser-section #endUserSelectFromAddress').click();
                $('.endUser-section #addressBook').val($('#endUser-address-id').val()).select2({
                    minimumResultsForSearch: -1
                }).trigger('change');
            }
        },

        settingUpShippingAddressByMDM: function(account, isReformatted, addressType, addressSelectionPending) {
            this.$(`.${addressType} #attn`).val(addressType === 'endUser-section' ? this.endUserAddressAttn : this.shippingAddressAttn);
            this.$(`.${addressType} #companyName`).val(isReformatted ? account.accountName : account.get('accountName'));
            this.$(`.${addressType} #line1`).val(isReformatted ? account.addressLine1 : account.get('addressLine1'));
            this.$(`.${addressType} #line2`).val(isReformatted ? account.addressLine2 : account.get('addressLine2'));
            this.$(`.${addressType} #line3`).val(isReformatted ? account.addressLine3 : account.get('addressLine3'));
            this.$(`.${addressType} #line4`).val(isReformatted ? account.addressLine4 : account.get('addressLine4'));
            this.$(`.${addressType} #locality`).val(isReformatted ? account.locality : account.get('locality'));
            this.$(`.${addressType} #city`).val(isReformatted ? account.town : account.get('town'));
            this.$(`.${addressType} #phone`).val(isReformatted ? account.phone : account.get('phone'));
            this.$(`.${addressType} #zipCode`).val(isReformatted ? account.zipCode : account.get('zipCode'));
            this.$(`.${addressType} #state`).val(isReformatted ? account.country.isocode + '-' + account.state : account.get('country').isocode + '-' + account.get('state'));

            if (addressType === 'endUser-section') {
                this.$('#endUserSelectedAddressId').val(isReformatted ? '' : (account.get('sapId') === '0000000000' ? '' : account.get('sapId')));

            } else {
                this.$('#selectedAddressId').val(isReformatted ? '' : (account.get('sapId') === '0000000000' ? '' : account.get('sapId')));
            }

            // trigger form submit call
            if (!addressSelectionPending) {

                if ($('.addressFromMDMSugestion-shipping').length) {
                    $('#selectedAddressId').val($('#boxId-shipping').val());
                    $('#mdmVerified').val('true');
                } else if ($('.shipping-section #selectFromAddress').prop('checked')) {
                    $('.shipping-section .newAddress-fieldset').removeAttr('disabled');
                }

                if ($('.addressFromMDMSugestion-endUser').length) {
                    $('#endUserSelectedAddressId').val($('#boxId-endUser').val());
                    $('#endUserMdmVerified').val('true');
                } else if ($('.endUser-section #endUserSelectFromAddress').prop('checked')) {
                    $('.endUser-section .newEndUseraddress-fieldset').removeAttr('disabled');
                }

                this.eventAgg.trigger('checkErrorAndSubmitFromStore');
            }
        },

        /**
         * On Country Change method
         * @param {Object} ev - Event object provided by the browser
         */
        onCountryChange: function (ev) {
            if (this.countries) {
                this.updateFieldsWithCountry(this.countries, ev);
            } else {
                this.countries = new ws.models.shippingCountry();
                this.countries.fetch({
                    success: (response) => {
                        this.updateFieldsWithCountry(response, ev);
                    }
                });
            }
        },

        /**
         * Modify rendered DOM elements
         */
        render: function () {
            // Check for every shipping component in the page.
            _.each(this.$('.comp-shipping'), function (container) {
                var $container = $(container);
                var $addressBookSelector = $container.find('#selectFromAddress');

                if ($addressBookSelector.length === 0) {
                    $addressBookSelector = $container.find('#endUserSelectFromAddress');
                }

                var $addressBookList = $container.find('#addressBook');

                this.disableAdressOptions({
                    currentTarget: $container.find('.address-type-selector:checked')[0]
                });

                if ($addressBookSelector.is(':checked')) {
                    // Mock event object.
                    this.onSelectAddressBookChanged({
                        currentTarget: $addressBookList[0]
                    });
                }
            }.bind(this));

            this.$datePickers.pikaday({
                format: dateFormat
            });

            /*
            this.$selectElements.select2({
                width: '100%',
                minimumResultsForSearch: -1
            });
            */
        },

        /**
         * Disable Adress fieldsets that is not checked
         * @param {Object} ev - Event object provided by the browser
         */
        disableAdressOptions: function (ev) {
            var $container = $(ev.currentTarget).parents('.comp-shipping');
            var $enabledAddressFieldset = $(ev.currentTarget).parents('.address-type-fieldset');
            this.$addressTypeFieldsets = $container.find('.address-type-fieldset');

            this.$addressTypeFieldsets.prop('disabled', true);
            this.$addressTypeFieldsets.find('select').prop('disabled', true);

            $enabledAddressFieldset.prop('disabled', false);
            $enabledAddressFieldset.find('select').prop('disabled', false);
        },

        /**
         * Handle changed address entry fieldset trigger
         * @param {Object} ev - Event object provided by the browser
         */
        onAddressEntryTypeChanged: function (ev) {
            var $container = $(ev.currentTarget).parents('.comp-shipping');
            var $enabledAddressFieldset = $(ev.currentTarget).parents('.address-type-fieldset');
            this.$addressTypeFieldsets = $container.find('.address-type-fieldset');

            $container.find('.required-error-message').hide();
            $container.find('#addressBook').removeClass('error');

            this.$addressTypeFieldsets.prop('disabled', true);
            this.$addressTypeFieldsets.find('select').prop('disabled', true);

            $enabledAddressFieldset.prop('disabled', false);
            $enabledAddressFieldset.find('select').prop('disabled', false);
            $container.find('.error').removeClass('error');

            this.cleanAllInputsAddress();

            $container.find('#addressBook').trigger('change');
            $container.find('.select-style.ckt-country').val(this.defaultNewAddressCountry).trigger('change');

            if ($(ev.currentTarget).attr('id') === 'newAddress' || $(ev.currentTarget).attr('id') === 'endUserNewAddress') {
                $container.find('#addressFromMDMSugestion').empty();
            }

            if ($container.hasClass('shipping-section') && $('.shipping-section #newAddress').prop('checked')) {
                this.shipVerifiedFromAddressBook = false;
            } else if ($container.hasClass('endUser-section') && $('.endUser-section #endUserNewAddress').prop('checked')) {
                this.endUserVerifiedFromAddressBook = false;
            }
        },

        updateValues: function () {
            if (!this.error) {
                $('#addressBook').val('null');
                $('.end-user-addrs #addressBook').val('null');
            }
        },

        checkAttackValue: function(e) {
            globals.attackValueCheck(e);
        },

        /**
         * Override additionalValidation method
         */
        additionalValidation: function () {
            ws.views.shipping.prototype.additionalValidation.call(this);

            this.checkShippingDate();

            let callMdmBasedOnSameAsCheck = true;
            if ($('#sameAsShippingAddress').prop('checked')) {
                callMdmBasedOnSameAsCheck = this.shipVerifiedFromAddressBook ? false : true;
            }

            if ((this.shipVerifiedFromAddressBook && $('.addressFromMDMSugestion-endUser').length) || (this.endUserVerifiedFromAddressBook && $('.addressFromMDMSugestion-shipping').length)) {
                callMdmBasedOnSameAsCheck = false;
            }

            if (this.addressValidationEnabled && callMdmBasedOnSameAsCheck && (!this.shipVerifiedFromAddressBook || !this.endUserVerifiedFromAddressBook) && ($('.addressFromMDMSugestion-shipping').length + $('.addressFromMDMSugestion-endUser').length < 2) && $('#enableMDMTrilliumAddressValidation').val() === 'false') {
                this.mdmFormValidation();
            } else {
                $('#mDMAddress').val('false');

                if (this.addressValidationEnabled) {
                    if ($('.addressFromMDMSugestion-shipping').length) {
                        $('#selectedAddressId').val($('#boxId-shipping').val());
                        $('#mdmVerified').val('true');
                    } else if ($('.shipping-section #selectFromAddress').prop('checked')) {
                        $('.shipping-section .newAddress-fieldset').removeAttr('disabled');
                    }

                    if ($('.addressFromMDMSugestion-endUser').length) {
                        $('#endUserSelectedAddressId').val($('#boxId-endUser').val());
                        $('#endUserMdmVerified').val('true');
                    } else if ($('.endUser-section #selectFromAddress').prop('checked')) {
                        $('.endUser-section .newEndUseraddress-fieldset').removeAttr('disabled');
                    }
                }

                this.updateValues();
            }
        },

        /**
         * Check shipping date
         */
        checkShippingDate: function () {
            const date = moment(this.$earliestRequiredShipDate.val(), dateFormat);
            this.$earlyRequiredShippingDateError.hide();

            if (date.isBefore(new Date(), 'day')) {
                this.error = true;
                this.$earlyRequiredShippingDateError.show();
            }
        },

        /**
         * Setting form shipping Address
         */
        setFormShippingAddress: function () {
            this.$addressBookSelect.val(this.$shippingAddressForm.val()).trigger('change.select2');
        },

        /**
         * Clear Quote
         */
        clearQuote: function () {
            if (this.$is3PLOrder.val() === 'true') {
                $.ajax({
                    url: globals.path.api.westcon.shoppingCartClearCart,
                    method: 'GET',
                    success: function (result) {
                        window.location = globals.path.api.westcon.clearQuoteCheckout;
                    },

                    error: function (e) {
                        console.log('error', e);
                    }
                });
            } else {
                window.location = globals.path.api.westcon.clearQuoteCheckout;
            }
        },

        /**
         * End User Address
         */
        toggleEndUserAddress: function () {
            const sameAsShippingAddress = this.$endUserAddressCheckbox.is(':checked');

            this.$endUserAddressCheckbox.val(sameAsShippingAddress);
            this.$endUserAddress.toggle(!sameAsShippingAddress);

            // Explicitly enable/disabled the select element due to a select2 behavior.
            // The iteration over the fieldsets looking for the disabled ones is
            // for an issue with the pseudoselector `:enabled` not workin. Thanks IE11
            // https://connect.microsoft.com/IE/feedback/details/722689/fieldsets-not-targeted-by-disabled-pseudo-class
            _.each(this.$endUserAddress.find('fieldset'), function (fieldset) {
                if (!$(fieldset).prop('disabled')) {
                    $(fieldset).find('select').prop('disabled', sameAsShippingAddress);
                }
            }, this);
        },

        /*Phone no. end user validation */
        phoneValidation: function() {
            if ($('.isEndUserValidPhone').html() === 'true') {
                $('#sameAsShippingAddress').prop('checked', false);
                this.$endUserAddress.show();
            }
        },

        /**
         * Populate address fields if user selects address from address book
         * @param {Object} ev - Event object provided by the browser
         */
        onSelectAddressBookChanged: function (ev) {
            var $container = $(ev.currentTarget).parents('.comp-shipping');
            let shippingSection = '';
            var $addressBookList = $container.find('#addressBook');
            var $newAddressCountryList = $container.find('#newAddressContainer #country');

            this.$addressTypeFieldsets = $container.find('.address-type-fieldset');
            if ($container.hasClass('shipping-section')) {
                shippingSection = 'shipping';
                this.$('#addressBookId').val($addressBookList.val());
            } else if ($container.hasClass('endUser-section')) {
                shippingSection = 'endCustomer';
                this.$('#endUserAddressBookId').val($addressBookList.val());
            }

            if ($addressBookList.val()) {
                let isMdmVerified = $addressBookList.find('option:selected').data('mdm-verified') === true || $addressBookList.find('option:selected').data('mdm-verified') === 'true' ? true : false;
                if (isMdmVerified && this.addressValidationEnabled) {
                    $container.find('.newAddress-fieldset').prop('disabled', true);
                    $container.find('.newAddress-fieldset').find('select').prop('disabled', true);
                } else {
                    $container.find('.newAddress-fieldset').prop('disabled', false);
                    $container.find('.newAddress-fieldset').find('select').prop('disabled', false);
                }

                this.$addressTypeFieldsets.find('#saveToAddressBook').prop('disabled', true).val('false');
                this.$addressTypeFieldsets.find('#saveToAddressBook').parent().addClass('hide');

                var addressData = $addressBookList.find('option:selected').data('attr');
                var country = _.findWhere(addressData, {name: 'country'});
                if ($container.hasClass('shipping-section')) {
                    this.shipVerifiedFromAddressBook = isMdmVerified;
                } else if ($container.hasClass('endUser-section')) {
                    this.endUserVerifiedFromAddressBook = isMdmVerified;
                }

                // When Address Book has a value, show pre-filed fields to show details address.
                this.$newAddressContainer.show();

                // If country is not the currently selected country,
                // then it needs to fetch and update the list of states.
                if (country.value !== $newAddressCountryList.val()) {
                    this.fetchStates = $.Deferred();
                    $newAddressCountryList.val(country.value).trigger('change');
                    this.fetchStates.done(function () {
                        this.updateInputsWithAddressBookData(addressData, $container, shippingSection);
                    }.bind(this));
                } else {
                    this.updateInputsWithAddressBookData(addressData, $container, shippingSection);
                }

                $container.find('#addressFromMDMSugestion').empty();
            } else {
                this.$addressTypeFieldsets.find('#saveToAddressBook').parent().removeClass('hide');
                this.$addressTypeFieldsets.find('#saveToAddressBook').prop('disabled', false).val('true');
            }
        },

        /**
         * Update mdm error message
         */
        displayErrorMessage: function(data) {
            var html = '<ul>';
            _.each(data.errors, function (error) {
                html += '<li>' + error.message + '</li>';
            });
            html += '</ul>';

            return html;
        },

        /**
         * Shipping and End user address mdm validation
         */
        mdmFormValidation: function () {
            this.error = true;
            globals.disableApp();
            var formData = {};
            var shippingAddress = {};
            var enduserAddress = {};

            if ($('.shipping-section #selectFromAddress').prop('checked')) {
                $('#addressBookId').remove();
            }

            if ($('.endUser-section #endUserSelectFromAddress').prop('checked')) {
                $('#endUserAddressBookId').remove();
            }

            if (this.shipVerifiedFromAddressBook || $('.addressFromMDMSugestion-shipping').length) {
                shippingAddress = {
                    shippingAddress: null
                };
            } else {
                this.shippingAddressAttn = $('.shipping-section').find('[name="shippingAddress.firstName"]').val();

                shippingAddress = {
                    shippingAddress: {
                        companyName: $('.shipping-section').find('[name="shippingAddress.companyName"]').val(),
                        line1: $('.shipping-section').find('[name="shippingAddress.line1"]').val(),
                        line2: $('.shipping-section').find('[name="shippingAddress.line2"]').val(),
                        line3: $('.shipping-section').find('[name="shippingAddress.line3"]').val(),
                        line4: $('.shipping-section').find('[name="shippingAddress.line4"]').val(),
                        locality: $('.shipping-section').find('[name="shippingAddress.locality"]').val(),
                        phone: $('.shipping-section').find('[name="shippingAddress.phone"]').val(),
                        postalCode: $('.shipping-section').find('[name="shippingAddress.postalCode"]').val(),
                        town: $('.shipping-section').find('[name="shippingAddress.town"]').val(),
                        region: {
                            isocode: $('.shipping-section').find('[name="shippingAddress.region.isocode"]').val()
                        },
                        country: {
                            isocode: $('.shipping-section').find('[name="shippingAddress.country.isocode"]').val()
                        }
                    }
                };
            }

            if (this.endUserVerifiedFromAddressBook || $('.addressFromMDMSugestion-endUser').length) {
                enduserAddress = {
                    endUserAddress: null
                };
            } else {
                this.endUserAddressAttn = $('.endUser-section').find('[name="endUserAddress.firstName"]').val();

                enduserAddress = {
                    endUserAddress: {
                        companyName: $('.endUser-section').find('[name="endUserAddress.companyName"]').val(),
                        line1: $('.endUser-section').find('[name="endUserAddress.line1"]').val(),
                        line2: $('.endUser-section').find('[name="endUserAddress.line2"]').val(),
                        line3: $('.endUser-section').find('[name="endUserAddress.line3"]').val(),
                        line4: $('.endUser-section').find('[name="endUserAddress.line4"]').val(),
                        locality: $('.endUser-section').find('[name="endUserAddress.locality"]').val(),
                        phone: $('.endUser-section').find('[name="endUserAddress.phone"]').val(),
                        postalCode: $('.endUser-section').find('[name="endUserAddress.postalCode"]').val(),
                        town: $('.endUser-section').find('[name="endUserAddress.town"]').val(),
                        region: {
                            isocode: $('.endUser-section').find('[name="endUserAddress.region.isocode"]').val()
                        },
                        country: {
                            isocode: $('.endUser-section').find('[name="endUserAddress.country.isocode"]').val()
                        }
                    }
                };
            }

            if (!($('#sameAsShippingAddress').prop('checked'))) {
                $.extend(formData, shippingAddress, enduserAddress);
                formData.sameAsShippingAddress = false;
            } else {
                $.extend(formData, shippingAddress);
                formData.endUserAddress = null;
                formData.sameAsShippingAddress = true;
            }

            this.$submitaddress.find('input[type="submit"]').attr('disabled', true);

            if (formData.endUserAddress || formData.shippingAddress) {
                this.shippingAddressModel.save(formData).done(function (data) {
                    this.$submitaddress.find('input[type="submit"]').removeAttr('disabled');
                    this.shippingAddressModel.isMdmValidated = true;

                    if ((data.shippingAddress && data.shippingAddress.error) || (!data.sameAsShippingAddress && data.endUserAddress && data.endUserAddress.error)) {
                        if (data.shippingAddress && data.shippingAddress.error) {
                            $('.mdmErrorShipping').children().html(this.displayErrorMessage(data.shippingAddress)).show();
                            $('.mdmErrorShipping').show();
                        }

                        if (!data.sameAsShippingAddress && data.endUserAddress && data.endUserAddress.error) {
                            $('.mdmErrorEndUser').children().html(this.displayErrorMessage(data.endUserAddress)).show();
                            $('.mdmErrorEndUser').show();
                        }

                        $('html, body').animate({
                            scrollTop: $('.alert:visible:first').offset().top - 200
                        }, 700);
                    } else if ((data.shippingAddress && data.shippingAddress.suggested.length) && (data.endUserAddress && data.endUserAddress.suggested.length)) {
                        this.updateValues();
                        this.eventAgg.trigger('storeAccountAddAddress', data, 'checkout');
                        $('#mdmVerified').val('true');
                        $('#endUserMdmVerified').val('true');
                    } else if (data.shippingAddress && data.shippingAddress.suggested.length === 0 && data.endUserAddress && data.endUserAddress.suggested.length === 0) {
                        this.updateValues();
                        if (data.endUserAddress.reformatted && data.shippingAddress.reformatted) {
                            $('#mdmVerified').val('true');
                            $('#endUserMdmVerified').val('true');

                            this.settingUpShippingAddressByMDM(data.shippingAddress.reformatted, true, 'shipping-section', true);
                            this.settingUpShippingAddressByMDM(data.endUserAddress.reformatted, true, 'endUser-section', false);
                        }
                    } else if (data.shippingAddress || data.endUserAddress) {
                        this.updateValues();
                        if (data.shippingAddress && data.shippingAddress.suggested.length) {
                            $('#mdmVerified').val('true');
                            this.eventAgg.trigger('storeAccountAddAddress', data.shippingAddress, 'checkout-ship');
                        } else if (data.shippingAddress && data.shippingAddress.reformatted) {
                            $('#mdmVerified').val('true');
                            this.settingUpShippingAddressByMDM(data.shippingAddress.reformatted, true, 'shipping-section', (data.endUserAddress && data.endUserAddress.suggested.length));
                        }

                        if (data.endUserAddress && data.endUserAddress.suggested.length) {
                            $('#endUserMdmVerified').val('true');
                            this.eventAgg.trigger('storeAccountAddAddress', data.endUserAddress, 'checkout-endUser');
                        } else if (data.endUserAddress && data.endUserAddress.reformatted) {
                            $('#endUserMdmVerified').val('true');
                            this.settingUpShippingAddressByMDM(data.endUserAddress.reformatted, true, 'endUser-section', (data.shippingAddress && data.shippingAddress.suggested.length));
                        }
                    }
                }.bind(this)).fail(function (resp) {
                    console.error('Could not add new address: ', resp);
                }.bind(this));
            }
        }
    });

}(westcon));
